/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateProfileEntryInputDataSchema = z.object({
	contents: z.string(),
})

export type CandidateProfileEntryInputDataSchema = z.infer<typeof candidateProfileEntryInputDataSchema>
